<div *ngIf="!displayUserManagement">
  <div id="userManagement" class="grid">
    <!--Upload choice button-->
    <div class="col-5 align-left" *ngIf="enableActions && (showExpress || AdminNumen)">
      <p-splitButton *ngIf="uploadItems && uploadItems.length >= 1" [styleClass]="'p-button-success'"
                     [label]="'LEFT.CONTAINER_COMPONENT.EXPRESS_BUTTON_LABEL' | translate" [icon]="'fa fa-upload'"
                     (onClick)="this.openUpload('EXPRESS')"
                     [model]="uploadItems"></p-splitButton>
    </div>
    <div class="col-5 align-left" *ngIf="enableActions && !showExpress">
      <p-splitButton *ngIf="uploadItems && uploadItems.length >= 1" [styleClass]="'p-button-success'"
                     [label]="'LEFT.CONTAINER_COMPONENT.UPLOAD_BUTTON_LABEL' | translate" [icon]="'fa fa-upload'"
                     (onClick)="this.openUpload('UNIT')"
                     [model]="uploadItems"></p-splitButton>
    </div>
    <!--Validation and signature-->
    <div class="col-3">
      <button *ngIf="isAdminUsers || AdminNumen" pButton type="button"
              [label]="'LEFT.CONTAINER_COMPONENT.MANAGE_USER_BUTTON_LABEL' | translate"
              [icon]="'fa fa-users'" class="p-button-info"
              (click)="openUserManager()"></button>
    </div>
    <div class="col-4 align-right">
      <button *ngIf="currentUser.permissions.wfValidSign.available" pButton type="button"
              [label]="'LEFT.CONTAINER_COMPONENT.VALID_AND_SIGN_BUTTON_LABEL' | translate"
              [icon]="'fa fa-pencil'" class="p-button-warning"
              (click)="openValidAndSign()"></button>
    </div>
  </div>

  <!--Search component-->
  <app-search></app-search>

  <!--Signature and validation component-->
  <app-signature-and-validation
    [listOfWorkflows]="listOfWorkflows"
    [(displayComponent)]="displayValidationAndSignature"></app-signature-and-validation>

  <!--
  <div class="user-managelent-modal" *ngIf="displayUserManagement">
    <p-dialog [(visible)]="displayUserManagement" [header]="'GROUP_MANAGEMENT.COMPONENT.COMPONENT_TITLE' | translate"
              [draggable]="false"
              [closable]="true"
              [resizable]="false"
              [modal]="true" [closeOnEscape]="true">
      <app-user-management [groupList]="groupList"></app-user-management>
    </p-dialog>
  </div>
  -->
</div>
<div *ngIf="displayUserManagement">
  <div class="flex flex-column">
    <div class="col-12 flex flex-row justify-content-between">
      <button pButton type="button" [label]="'LEFT.CONTAINER_COMPONENT.MANAGE_USER_RETURN_BUTTON_LABEL' | translate"
              [icon]="'fa fa-arrow-circle-left'" class="p-button-info col-4"
              (click)="closeUserManager()"></button>
      <button *ngIf="AdminNumen"
              pButton type="button"
              [label]="'LEFT.CONTAINER_COMPONENT.MANAGE_USER_IMPORT_WSO2_BUTTON_LABEL' | translate"
              [icon]="'fa fa-arrow-circle-up'" class="p-button-info col-6"
              (click)="exportWso2()">
      </button>
    </div>
    <div class="col-12">
      <app-group-management></app-group-management>
    </div>
  </div>
</div>
<p-dialog [(visible)]="displayExportPopup" [modal]="true" [closable]="true"
          [header]="'Export WSO2 - Résultat'" [style]="{width: '50vw'}">

  <ng-container *ngIf="exportedData">
    <div class="summary">
      <p><strong>Total utilisateurs créés :</strong> {{ exportedData.usersCreated?.length || 0 }}</p>
      <p><strong>Total utilisateurs existants :</strong> {{ exportedData.usersExisted?.length || 0 }}</p>
      <p><strong>Total échecs :</strong> {{ exportedData.usersFailure?.length || 0 }}</p>
    </div>

    <p-accordion>
      <p-accordionTab *ngIf="exportedData.usersCreated?.length > 0"
                      header="Utilisateurs créés ({{ exportedData.usersCreated.length }})">
        <ul>
          <li *ngFor="let user of exportedData.usersCreated">
            <strong>{{ user.key }}</strong> : {{ user.value }}
          </li>
        </ul>
      </p-accordionTab>

      <p-accordionTab *ngIf="exportedData.usersExisted?.length > 0"
                      header="Utilisateurs existants ({{ exportedData.usersExisted.length }})">
        <ul>
          <li *ngFor="let user of exportedData.usersExisted">
            <strong>{{ user.key }}</strong> : {{ user.value }}
          </li>
        </ul>
      </p-accordionTab>

      <p-accordionTab *ngIf="exportedData.usersFailure?.length > 0"
                      header="Échecs ({{ exportedData.usersFailure.length }})">
        <ul>
          <li *ngFor="let user of exportedData.usersFailure">
            <strong>{{ user.key }}</strong> : {{ user.value }}
          </li>
        </ul>
      </p-accordionTab>
    </p-accordion>
  </ng-container>
</p-dialog>
